import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import { RootState } from '../../app/store';
import { setUserToLS } from '../../helpers/localstorage-helper';
import {
  changeAvailableLoyaltyPoints,
  changeAvailableRewardPoints,
  changeAvailableShoppingPoints,
  changeUserInfo,
  updateVirtualOfficeLicence
} from '../../slices/auth-slice';
import { hubsData } from './HubsData';
import { MergedPackageModel, TradingPackageModel } from './Maeketplace.types';
import {
  addHubAsync,
  getAkashaHubsAsync,
  getFlipmeCardsAsync,
  getPackageAsync,
  getPackagesAsync,
  getPackagesBigWhaleAsync,
  getPackagesTradingAsync,
  getTravelPackagesAsync,
  purchaseBigWhalePackageAsync,
  purchaseNFTPackageAsync,
  purchaseTradingPackageAsync,
  purchaseTravelPackageAsync,
  getTravelutionSubscriptionsAsync,
  purchaseSubscriptionAsync,
  depositAkashaAsync,
  getDepositAkashaInfoAsync,
  getPowerPacksHubsAsync,
  getFinUpAsync,
  autoStakeSuperNodeAsync,
  purchasePackageAsync
} from './Marketplace.requests';
import { ErrorToast } from '../../components';
import { MY_HUBS_POWERPACKS } from '../../routes/routes';

import {
  getAkashaWalletBalanceFromBase,
  getAkashaWalletBalanceFromUltron
} from '../../helpers/helperFunctions';

export const getMarketplace = createAsyncThunk('getMarketplace', async () => {
  const { data } = await getPackagesAsync();

  return {
    hubs: data?.products
  };
});

export const getTradingHubs = createAsyncThunk('getTradingHubs', async () => {
  const { data: userPackages } = await getPackageAsync();
  const { data } = await getPackagesTradingAsync();

  let packages = data!.packages;

  const newHubs = packages
    .map((hub) => {
      // let item = hubsData.find((i) => i.id === hub.packageId);

      return {
        ...hub,
        id: hub.packageId,
        title: hub.name
      };
    })
    .reverse();

  return {
    hubs: newHubs as any,
    userPackages: userPackages!.orders
  };
});

export const getBigWhale = createAsyncThunk('getBigWhale', async () => {
  //const { data: userPackages } = await getPackageAsync();
  const { data } = await getPackagesBigWhaleAsync();

  let packages = data!.packages;

  const newHubs = packages
    .map((hub) => {
      // let item = hubsData.find((i) => i.id === hub.packageId);

      return {
        ...hub,
        id: hub.packageId,
        title: hub.name,
        willyMemeCoins: hub.price,
        whaleBenefits: hub.benefits
      };
    })
    .reverse();

  return {
    hubs: newHubs as any
    //userPackages: userPackages!.orders
  };
});

export const getTravelPackages = createAsyncThunk(
  'getTravelPackages',
  async () => {
    const { data } = await getTravelPackagesAsync();

    let packages = data!.packages;

    const newHubs = packages.map((hub) => {
      return {
        ...hub,
        id: hub.packageId,
        title: hub.name,
        willyMemeCoins: hub.price,
        whaleBenefits: hub.benefits,
        tickets: `+${hub.tickets} ${hub.tickets !== 5 ? 'ticket' : 'tickets'}`
      };
    });

    return {
      hubs: newHubs as any,
      userPackages: [] // userPackages!.orders
    };
  }
);

export const getTravelutionSubscriptions = createAsyncThunk(
  'getTravelutionSubscriptions',
  async () => {
    const { data } = await getTravelutionSubscriptionsAsync();
    let packages = data!.subscriptions;
    const newHubs = packages.map((hub: any) => {
      return {
        ...hub,
        id: hub.id,
        packageId: hub.id,
        title: hub.name,
        subtitle: `+ ${hub.myLifePoints}`,
        willyMemeCoins: hub.price,
        whaleBenefits: hub.benefits,
        tickets: 'MYLIFE POINTS'
      };
    });

    return {
      hubs: newHubs as any,
      userPackages: [] // userPackages!.orders
    };
  }
);

export const getFinUp = createAsyncThunk('getFinUp', async () => {
  const { data } = await getFinUpAsync();

  let packages = data!.packages;

  return {
    hubs: packages as any
  };
});

export const getFlipmeCards = createAsyncThunk('getFlipmeCards', async () => {
  const { data } = await getFlipmeCardsAsync();

  let packages = data!.packages;

  const newHubs = packages.map((hub) => {
    return {
      ...hub,
      id: hub.packageId,
      title: hub.name,
      willyMemeCoins: hub.price,
      whaleBenefits: hub.benefits,
      tickets: hub.subtitle2
    };
  });
  return {
    hubs: newHubs as any
  };
});

export const getPowerPacksHubs = createAsyncThunk(
  'getPowerPacksHubs',
  async () => {
    const { data } = await getPowerPacksHubsAsync();

    const newPackages = data!.packages.map((pkg) => ({
      ...pkg,
      name: 'Power Pack'
    }));

    return {
      hubs: newPackages as any
    };
  }
);

export const getAkashaHubs = createAsyncThunk('getAkashaHubs', async () => {
  const { data } = await getAkashaHubsAsync();

  let packages = data!.packages;

  const newHubs = packages.reverse();

  return {
    hubs: newHubs as any
  };
});

export const getDepositAkashaInfo = createAsyncThunk(
  'getDepositAkashaInfo',
  async ({ userPackageId }: { userPackageId: string }) => {
    try {
      const { data } = await getDepositAkashaInfoAsync({
        userPackageId
      });

      return data;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const autoStakeSuperNode = createAsyncThunk(
  'autostakeSuperNode',
  async ({
    userPackageId,
    isActive,

    history
  }: {
    userPackageId: string;
    isActive: boolean;
    history: any;
  }) => {
    try {
      const { data } = await autoStakeSuperNodeAsync({
        userPackageId,
        isActive
      });

      history.push(MY_HUBS_POWERPACKS);

      return data;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const depositAkasha = createAsyncThunk(
  'depositAkasha',
  async (
    {
      userPackageId,
      amount,
      token,
      chain,
      wallet,
      setStep
    }: {
      userPackageId: number;
      amount: number;
      token: string | undefined;
      chain: string;
      wallet: string;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      await depositAkashaAsync({
        userPackageId,
        amount,
        token,
        chain
      });

      if (chain === 'base') {
        await getAkashaWalletBalanceFromBase(
          wallet,
          process.env.REACT_APP_AKASHA_ADDRESS_FROM_BASE!,
          process.env.REACT_APP_WULX_DECIMALS!
        );
      } else {
        await getAkashaWalletBalanceFromUltron(
          wallet,
          process.env.REACT_APP_AKASHA_ADDRESS!,
          process.env.REACT_APP_WULX_DECIMALS!
        );
      }
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const addHub = createAsyncThunk(
  'addHub',
  async (
    {
      packageId,
      currencyType,
      networkType,
      licenceId,
      userDiscountCodeId,
      step,
      setStep
    }: {
      packageId: number;
      currencyType: number;
      networkType: number | null;
      licenceId: number | null;
      userDiscountCodeId: number | null;
      step: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await addHubAsync({
        packageId,
        currencyType,
        networkType,
        licenceId,
        userDiscountCodeId
      });

      const state = getState() as RootState;

      setStep(step);

      if (currencyType === 3) {
        dispatch(
          changeAvailableRewardPoints(data!.userTickets.availableRewardPoints)
        );
      } else if (currencyType === 2) {
        dispatch(
          changeAvailableShoppingPoints(data!.userTickets.shoppingPoints)
        );
      } else if (currencyType === 4) {
        dispatch(changeAvailableLoyaltyPoints(data!.userTickets.loyaltyPoints));
      }

      if (licenceId !== null) {
        dispatch(updateVirtualOfficeLicence(data!.userVirtualOfficeLicence));

        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets,
            currentVirtualOfficeLicence: data!.userVirtualOfficeLicence
          }
        };

        setUserToLS(user);
      } else {
        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets
          }
        };

        setUserToLS(user);
      }

      return {
        userPackage: data!.userPackage,
        currencyType
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const purchasePackage = createAsyncThunk(
  'purchasePackage',
  async ({
    packageId,
    licenceId,
    currency,
    networkType,
    handleSuccess
  }: {
    packageId: number;
    licenceId: number | null;
    networkType: number | null;
    currency: string | null;
    handleSuccess: () => void;
  }) => {
    try {
      const { data } = await purchasePackageAsync({
        packageId,
        licenceId,
        currency,
        networkType
      });

      handleSuccess();

      return data?.order;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
